import { v1 as uuidv1 } from 'uuid';
import {
  Box,
  Card,
  CardMedia,
} from '@mui/material';
import './FillInTheBlankPageThumbnail.scss';
import TextLines from '../../../text/TextLines';
import { BLANK_SPACE } from '../FillInTheBlankUtils';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  cardConfig: [{
    card: {
      audio: null,
      image: null,
      video: null,
    },
    fitbList: [],
  }],
  isSmallThumbnail: false,
};

export default function FillInTheBlankPageThumbnail(p) {
  const {
    cardConfig,
    isSmallThumbnail,
  } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <div className='fill-in-the-blank-page-thumbnail-component vizzle-fill-in-the-blank-page-thumbnail'>
      {
        cardConfig.map((c, index) => {
          const caredId = uuidv1();
          return (
            <Card
              id={caredId}
              key={caredId}
              className={`fill-in-the-blank-page-thumbnail vizzle-fitb-thumbnail-page-${index}`}
            >
              {
                c.image ? (
                  <CardMedia
                    className='fill-in-the-blank-page-thumbnail-image'
                    image={c.image}
                    title='Fill in the Blank'
                  />
                )
                  : (
                    <Box
                      component='div'
                      className='fill-in-the-blank-page-thumbnail-placeholder'
                    >
                      Image/Video
                    </Box>
                  )
              }
              <div className={`${isSmallThumbnail ? 'small-gap' : 'gap'}`} />
              {
                c.fitbList && c.fitbList.length > 0 ? (
                  <div className={`fill-in-the-blank-questions-container ${isSmallThumbnail ? 'small-padding' : ''}`}>
                    {/* {c.fitbList[0].question.question} */}
                    <Box display='flex' alignItems='baseline' position='relative'>
                      <TextLines textLines={c.fitbList[0].question.preBlank} isThumbnail={isSmallThumbnail} />
                      {BLANK_SPACE}
                      <TextLines textLines={c.fitbList[0].question.postBlank} isThumbnail={isSmallThumbnail} />
                    </Box>
                    {c.fitbList.length > 1 && (
                      <div>
                        {c.fitbList.length - 1} more
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='fill-in-the-blank-page-thumbnail-placeholder'>
                    Fill in the Blank Questions
                  </div>
                )
              }
            </Card>
          );
        })
      }
    </div>
  );
}
